module.exports = __webpack_public_path__ + "img/new-logo-mkb.21a02d91.png";